import { useContext, useEffect } from 'react'
import AuthContext from '../Contexts/AuthContext'
import { useTranslation } from 'react-i18next'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import { Accordion, AccordionTab } from 'primereact/accordion'
import ReligiousPlaceDetailsComponent from './ReligiousPlaceDetailsComponent'
import ReligiousPlaceFolowersComponent from './ReligiousPlaceComponent/ReligiousPlaceFolowersComponent'
import ReligiousPlaceEventsComponent from './ReligiousPlaceComponent/ReligiousPlaceEventsComponent'
import ReligiousPlaceAmenitiesComponent from './ReligiousPlaceComponent/ReligiousPlaceAmenitiesComponent'
import ReligiousPlaceCeremonyTimesComponent from './ReligiousPlaceComponent/ReligiousPlaceCeremonyTimesComponent'
import ReligiousPlaceForm from '../App/ReligiousPlaceForm'
import PlacePictures from '../App/PlacePictures'
import AppBodyComponent from './AppBodyComponent'
import PaymentFormComponent from './PaymentFormComponent'

function UserHomeMyPlacesComponent() {

    const { t } = useTranslation('user_home');
    const navigate = useNavigate()
    const {userAuth, setActiveMenu} = useContext(AuthContext)
    useEffect(()=>{
        setActiveMenu(3)
    },[])

    return (
        <AppBodyComponent>
        <div className='flex flex-column gap-2 w-full'>
            <div className='font-bold text-xl'>{t('user_home_place_page_title')}</div>
            {userAuth?.user?.religious_place_access_key ? 
            <div className='flex flex-column gap-2 w-full'>
                <Accordion>
                    <AccordionTab header={t('user_home_my_place_my_place')}>
                        <ReligiousPlaceForm />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_my_pictures')}>
                        <PlacePictures />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_my_community')}>
                        <ReligiousPlaceFolowersComponent access_key={userAuth?.user?.religious_place_access_key} />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_my_events')}>
                        <ReligiousPlaceEventsComponent access_key={userAuth?.user?.religious_place_access_key} />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_my_amenities')}>
                        <ReligiousPlaceAmenitiesComponent user_access_key={userAuth?.user?.access_key} />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_ceremony_times')}>
                        <ReligiousPlaceCeremonyTimesComponent user_access_key={userAuth?.user?.access_key} />
                    </AccordionTab>
                    <AccordionTab header={t('user_home_my_place_payments_stripe')}>
                        <PaymentFormComponent
                            user_access_key={userAuth?.user?.access_key}
                            religious_place_access_key={userAuth?.user?.religious_place_access_key}
                        />
                    </AccordionTab>
                </Accordion>
            </div> :
            <div className='flex flex-column gap-4 align-items-center mt-4'>
                <div className='text-xl font-bold text-center'>{t('user_home_no_myplace_title')}</div>    
                <div className='text-center'>{t('user_home_no_myplace_message')}</div>    
                <Button className='w-max' label={t('user_home_no_myplace_button')} onClick={()=>navigate('/app/register_place')} />
            </div>}
        </div>
        </AppBodyComponent>
    )
}

export default UserHomeMyPlacesComponent